<template>
  <div class="file">

    <div class="talTitle">
      <ul :style="fileArr.length ? '' : 'visibility: hidden;'">
        <li>序号</li>
        <li>文档名称</li>
        <li>进度</li>
        <li></li>
        <li>源语言</li>
        <li>删除</li>
      </ul>
    </div>
    <!-- action="/api/v1/file/upload"
    :data = dataa-->
    <div class="upload_folder" v-if="fileArr.length ? false : true">
      上传文件夹
      <input ref="file" type='file' name="file" webkitdirectory @change.stop="changesData" />
    </div>
    <el-upload class="upload-demo" drag action :http-request="uploadSectionFile" multiple :show-file-list="false"
      :limit="privatization" :on-exceed="handleExceed" :file-list="fileArr" :before-upload="beforeUploadFile"
      :on-change="uploadChange" :accept="acceptStr">
      <div class="uploadBox" v-if="fileArr.length ? false : true">
        <i></i>
        <img src="../../assets/imgs/project/normal_upload.png" alt />
        <div class="el-upload__text">
          支持{{formatArr}}格式，拖拽或点击上传
          <em style="display:block">单个文件{{fileLimit}}M以下，最多10个文件</em>
        </div>
      </div>
      <ul class="tab">
        <li v-for="(item, index) in fileArr" :key="index">
          <span class="serial">{{ index + 1 }}</span>
          <span class="nam">
            <img :src="item.imgSrc" alt />
            {{ item.name }}
          </span>
          <span class="progress">
            <!-- <template slot-scope="scope"> -->
            <el-progress :show-text="false" :stroke-width="8" :status="item.exception"
              :percentage="isNaN(item.percentage) ? 100 : item.percentage" class="progress"></el-progress>
            <!-- {{percentageFn(scope.$index, scope.row)}} -->
            <p>{{ item.percentage + (isNaN(item.percentage) ? "" : "%") }}</p>
            <!-- </template> -->
          </span>
          <span class="siz"></span>
          <span class="source1">{{ item.source }}</span>
          <span class="del">
            <!-- <template slot-scope="scope"> -->
            <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
              <i class="icon-delete" @click.stop="handleDelete(index)"></i>
            </el-tooltip>
            <!-- </template> -->
          </span>
        </li>
      </ul>
      <div class="bot_box" v-if="fileArr.length ? true : false">
        <span>*点击或拖拽上传</span>
        <el-tooltip class="item" effect="dark" content="全部清空" placement="bottom-start">
          <i class="dele_all" @click.stop="messageIf"></i>
        </el-tooltip>
      </div>
      <!-- </template> -->
    </el-upload>
    <div class="source">
      <el-popover placement="top-start" trigger="hover" v-model="visibleLef">
        <div class="languageBox"
          :style="{'width': (80 + Math.floor(LangList.length / 13 + 1) * 110 + Math.floor(LangList.length / 13 - 1) * 40) + 'px'}">
          <template v-for="(item, index) in LangList">
            <button :key="index" @click="getSourceLeft(item)" :disabled="isChoiceSourceLanguage(item)" :style="
               isChoiceSourceLanguage(item)? 'cursor: not-allowed;color: #C0C4CC' : ''"
              style="text-align: center;padding:0 5px">
              {{ item.sourceLangName }}
            </button>
          </template>
        </div>
        <el-input slot="reference" v-model="sourceLeft" placeholder="源语言"
          :suffix-icon="visibleLef ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" readonly="readonly"></el-input>
      </el-popover>
      <i class="icon-right" @click="switchover"></i>
      <el-popover placement="top-start" trigger="hover" v-model="visibleRig">
        <p v-show="!LangList2.length">请先选择源语言</p>
        <div class="languageBox" v-show="LangList2.length"
          :style="{'width': (80 + Math.floor(LangList.length / 13 + 1) * 110 + Math.floor(LangList.length / 13 - 1) * 40) + 'px'}">
          <template v-for="(item, index) in LangList2">
            <button :key="index" @click="getSourceRight(item)" :disabled="item.status == 0" :style="
                item.status == 0 ? 'cursor: not-allowed;color: #C0C4CC' : ''
              " style="text-align: center; padding:0 5px">
              {{ item.targetLangName }}
            </button>
          </template>
        </div>
        <el-input slot="reference" v-model="sourceRight" placeholder="目标语言"
          :suffix-icon="visibleRig ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" readonly="readonly"></el-input>
      </el-popover>
      <!-- <el-select v-if="selectShow == 'hospital'" class="fieldSel" v-model="targetLang" placeholder="目标语言" @change="getSourceRight1">
        <el-option v-for="(item, index) in LangList2" :key="index" :label="item.targetLangName"
          :value="item.targetLang">
        </el-option>
      </el-select> -->
      <el-select class="domainInp fieldSel" v-model="region" placeholder="领域" @change="DomainChange">
        <el-option v-for="(item, index) in domainList" :key="index" :label="item.transDomainName"
          :value="item.transDomainCode">
        </el-option>
      </el-select>
    </div>
    <button class="toFileSet themeGoBut" @click="toFileSet">下一步</button>
    <messageBox v-if="mesBox" :isShow="mesBox" tit="友情提示" txt="确定清空文件吗？" :imgSrc="imgSrc1" @message="empty"
      @messageIf="messageIf"></messageBox>
    <div v-show="false">{{ refresh }}</div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import messageBox from "@/common/messageBox.vue";
// import { FilterFileCategory, LimitSize } from '../../../public/extract'
// import { setTimeout } from "timers";
export default {
  name: "file",
  data() {
    return {
      fileArr: [],
      dataa: {},
      form: {
        region: "中文"
      },
      LangList: [],
      LangList2: [],
      percentage1: 0,
      fileSize: 1,
      sourceLeft: "",
      sourceRight: "",
      sourceLang: "",
      targetLang: "",
      mesBox: false,
      standard: true,// 用来处理选择语言弹框
      visibleLef: false,
      visibleRig: false,
      imgSrc1: require("../../assets/imgs/project/qr_code_bg.png"), // 弹窗title背景图
      filePathList: [],
      host: "",
      keyPrefix: "",
      sign: {},
      ts: "",
      file: "",
      token: "",
      obp: true,
      formData: new FormData(),
      refresh: 0,
      region: "",
      domainList: "",
      value: '',// 左边语言对
      filesArray: [],
      formatArr: "",
      acceptStr: "",
      fileLimit: "",
      filesName: "",// 文件夹名字
    };
  },
  computed: {
    privatization() {
      return 10
    }
  },
  created() {
    var that = this;
    this.getLangList(1); // 获取源语言
    // this.getLangList(2); // 获取目标语言
    // this.getDomainList();
    // process.env.VUE_APP_NAME !== "drill"
    this.formatArr = FilterFileCategory().formatArr.join("、")
    this.acceptStr = FilterFileCategory().acceptArr.join(",")
    this.fileLimit = LimitSize().limit
    // if (process.env.VUE_APP_NAME === "nation") {
    //   this.notGetLong = true;
    // }
    /*if (process.env.VUE_APP_NAME !== "hospital") {

      if (process.env.VUE_APP_NAME !== "drill") {
        this.standard = true
      } else {
        this.standard = false
      }

    } else {
      this.standard = false
    }
    if (process.env.VUE_APP_NAME === "nation") {
      this.standard = false
    }
    if (process.env.VUE_APP_HOSPITAL === "demo") {
      this.standard = true
    }*/

  },
  components: {
    messageBox
  },
  methods: {

    // 切换语言
    switchover() {

      let sourceLeft = this.sourceLeft;
      let sourceLang = this.sourceLang;
      let targetLang = this.targetLang;
      let sourceRight = this.sourceRight;

      if (!sourceLeft && !sourceLang && !targetLang && !sourceRight) {
        return
      }
      this.sourceLang = targetLang
      this.targetLang = sourceLang
      this.sourceLeft = sourceRight;
      this.sourceRight = sourceLeft;
      this.getLangList(2, this.sourceLang); // 获取语言对  目标语言
      this.getDomainList(this.sourceLang, this.targetLang)
    },
    // 获取领域
    getDomainList(sourceLangCode, targetLangCode) {
      var that = this;
      that.region = "";
      var params = {
        sourceLangCode,
        targetLangCode,
      };
      this.catReq1Service("/api/v1/common/queryTransDomain", params).then(
        function (response) {
          if (!response.success) {
            return;
          }
          that.domainList = response.result;
          if (that.domainList[0]) {
            that.region = that.domainList[0].transDomainCode;
            that.domainName = that.domainList[0].transDomainName;
          }
        }
      );
    },
    //选择源语言值后转换为对象 --- 源语言
    getLangeObjectLeft(v) {
      let that = this
      this.LangList.forEach(item => {
        if (item.sourceLang == v) {
          that.getSourceLeft(item)
        }
      });
    },
    //选择源语言值后转换为对象 --- 目标语言
    getLangeObjectRight(v) {
      let that = this
      this.LangList2.forEach(item => {
        if (item.targetLang == v) {
          that.getSourceRight(item)
        }
      });
    },
    // 是否可选
    isChoiceSourceLanguage(item) {
      // if (item.sourceLangName == "中文" && this.sourceRight !== "" && this.sourceRight !== "中文") {
      //   return false
      // }
      // if (this.sourceRight !== "" && this.sourceRight !== "中文") {
      //   return true
      // } else {

      // }
      return item.status == 0 || item.sourceLangName === this.sourceRight
    },
    // 选择领域事件
    DomainChange(query) {
      this.fieldCode = query;
      let obj = {};
      obj = this.domainList.find(item => {
        return item.transDomainCode === query; //筛选出匹配数据
      });
      this.domainName = obj.transDomainName;
      //console.log(this.domainName,this.fieldCode)
    },
    // 获取语言
    getLong(path, param) {
      var that = this;
      this.catReq1Service(
        `/api/v1/file/language`,
        {
          path
        },
        "post",
        2
      ).then(function (response) {
        if (!response.success) {
          return;
        }
        var data = response.result;
        if (data == null) {
          // that.fileArr.forEach(item => {
          //   if (item.uid === param.file.uid) {
          //     item.wordNumber = 0;
          //   }
          // });
          that.refresh++;
          return;
        }

        that.fileArr.forEach(item => {
          if (item.uid === param.file.uid) {
            // vm.$set(vm.item, 'source', response.data.result.dataValue)
            item.source = data.sourceLangName || "";
            // item.wordNumber = data.remark || "";
            // that.fileArr.item = Object.assign({}, that.fileArr.item, { source: data})
          }
        });
        if (true) {
          if (!that.sourceLeft && data.sourceLang != null && 'hospital' !== process.env.VUE_APP_NAME) {
            that.getLangList(2, data.sourceLang);
            that.sourceLeft = data.sourceLangName;
            that.sourceLang = data.sourceLang;
          }
        } else {
          that.LangList.forEach(item => {
            if (item.sourceLangName === data.sourceLangName) {
              // that.getLangList(2, data.sourceLang);
              if (!that.sourceLeft && data.sourceLang != null) {
                that.sourceLeft = data.sourceLangName;
                that.sourceLang = data.sourceLang;
                if (that.sourceLeft == "中文" && that.sourceLang == "zh") {
                  that.sourceRight = "英语"
                  that.targetLang = "en"

                } else {
                  that.sourceRight = "中文"
                  that.targetLang = "zh"
                }
                that.getDomainList(that.sourceLang, that.targetLang)
              }

            }
          })
        }
        that.refresh++;
        // that.fileArr = ary;
        // console.log(that.fileArr);
      });
    },
    genID(length) {
      return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
    },
    // 上传文件夹
    changesData(e) {
      if (this.$refs.file.files[0].webkitRelativePath) {
        let relativePath = this.$refs.file.files[0].webkitRelativePath
        this.filesName = relativePath.split("/")[0]
      }
      let that = this
      this.filesArray = Object.values(this.$refs.file.files); //对象转化为数组
      this.filesArray.forEach(async (item, index) => {
        item.uid = that.genID(13)
        item.percentage = 0
        switch (that.typeReg(item.name)) {
          case "pdf":
            item.imgSrc = require("../../assets/imgs/project/press_pdf.icon.png");
            this.qwer = "pdf";
            break;
          case "doc":
            item.imgSrc = require("../../assets/imgs/project/press_word.icon.png");
            this.qwer = "doc";
            break;
          case "docx":
            item.imgSrc = require("../../assets/imgs/project/press_word.icon.png");
            break;
          case "ppt":
            item.imgSrc = require("../../assets/imgs/project/press_ppt.icon.png");
            break;
          case "pptx":
            item.imgSrc = require("../../assets/imgs/project/press_ppt.icon.png");
            break;
          case "xls":
            item.imgSrc = require("../../assets/imgs/project/press_xlsx.icon.png");
            break;
          case "xlsx":
            item.imgSrc = require("../../assets/imgs/project/press_xlsx.icon.png");
            break;
          case "txt":
            item.imgSrc = require("../../assets/imgs/project/txt.png");
            break;
          case "html":
            item.imgSrc = require("../../assets/imgs/project/html.png");
            break;
          case "htm":
            item.imgSrc = require("../../assets/imgs/project/html.png");
            break;
          case "jpg":
            item.imgSrc = require("../../assets/imgs/project/tupian.png");
            break;
          case "png":
            item.imgSrc = require("../../assets/imgs/project/tupian.png");
            break;
          case "bmp":
            item.imgSrc = require("../../assets/imgs/project/tupian.png");
            break;
          case "xlf":
            item.imgSrc = require("../../assets/imgs/project/xlf.png");
            break;
          case "eml":
            item.imgSrc = require("../../assets/imgs/project/eml.png");
            break;
          default:
            break;
        }
        let code = localStorage.getItem("myCompanyCode");
        let re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到后缀
          resultArr = re.exec(item.name);
        let type = resultArr[2];
        let params = { companyCode: code, fileType: "project" };
        let url = "/api/v1/file/getUploadSign";
        const res = await this.catReq1Service(url, params)
        if (!res.success) {
          return;
        }

        let data = res.result;
        that.host = data.host;
        let key = data.keyPrefix + "." + type;
        delete data.keyPrefix;
        delete data.host;
        that.formData = new FormData();
        that.formData.append("key", key);
        Object.keys(data).forEach(function (key) {
          that.formData.append(key, data[key]);
        });
        that.formData.append("file", item);
        if (that.fileArr.length < 10) {
          that.fileArr.push(item)
        } else {
          this.$message.closeAll();
          this.$message({
            message: "最多10个文件",
            type: "warning"
          });
          return
        }
        const isDOCX = type === "docx";
        const isDOC = type === "doc";
        const isTXT = type === "txt";
        const isXLS = type === "xls";
        const isXLSX = type === "xlsx";
        const isPDF = type === "pdf";
        const isPPT = type === "ppt";
        const isPPTX = type === "pptx";
        const isHTML = type === "html";
        const isLt20M = item.size / 1024 / 1024 < 20;
        if (FilterFileCategory(type).isFormat) {
          this.fileArr.pop();
          this.$message.closeAll();
          this.$message({
            message: `只支持 ${FilterFileCategory(type).formatArr.join("、")}格式!`,
            type: "warning"
          });

          return
        }
        if (item.size < 1) {

          this.$message.closeAll();
          this.$message({
            message: "不支持上传空文件",
            type: "warning"
          });
          return;
        }
        if (!LimitSize(item.size).size) {
          this.fileArr.pop();
          this.$message.closeAll();
          this.$message({
            message: `上传文件大小不能超过 ${LimitSize(file.size).limit}MB!`,
            type: "warning"
          });

          return;
        }
        that.fileArr.slice(0, -1).forEach((i, index) => {
          if (i.name == item.name) {
            this.$message.closeAll();
            this.$message({
              message: "已过滤文件名重复的文件!",
              type: "warning"
            });
            that.fileArr.splice(index, 1);

            return false;
          }
        });
        that.getFileHosts(item);
      })
    },
    // 文件夹上传的第二个函数
    getFileHosts(param) {
      let that = this;
      // alert(that.host)
      let FileController = that.host;
      let config = {
        onUploadProgress: (progressEvent) => {
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          param.percentage = percentCompleted
        }

      }
      // let config = {
      //   onUploadProgress: progressEvent => {
      //     const complete =
      //       ((progressEvent.loaded / progressEvent.total) * 100) | 0;
      //     param.onProgress({ percent: complete });
      //   }
      // };
      axios
        .post(FileController, that.formData, config)
        .then(function (response) {
          if (!response) {
            return;
          }
          let params = {
            file: param
          }
          if (!that.notGetLong) {
            that.getLong(response.data.result.fileName, params);
          }
          that.filePathList.push(response.data.result);
          that.fileArr.forEach(item => {
            if (item.uid === param.uid) {
              item.path = response.data.result.fileName;
            }
          });
        })
        .catch(function (error) {
          that.fileArr.forEach(item => {
            if (item.name == param.name) {
              item.exception = "exception";
              item.percentage = "上传失败";
            }
          });
        });
    },
    // 

    // 上传的第二个函数
    getFileHost(param) {
      var that = this;
      // alert(that.host)
      var FileController = that.host;
      var config = {
        onUploadProgress: progressEvent => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        }
      };
      axios
        .post(FileController, that.formData, config)
        .then(function (response) {
          if (!response) {
            return;
          }
          if (!that.notGetLong) {
            that.getLong(response.data.result.fileName, param);
          }

          that.filePathList.push(response.data.result);
          that.fileArr.forEach(item => {
            if (item.uid === param.file.uid) {
              item.path = response.data.result.fileName;
            }
          });
        })
        .catch(function (error) {
          // console.log(param, "paramparamparam");
          that.fileArr.forEach(item => {
            if (item.name == param.file.name) {
              item.exception = "exception";
              item.percentage = "上传失败";
            }
          });
        });
    },
    // 上传函数——获取签名
    uploadSectionFile(param) {
      if (param.file.obp) {
        return;
      }

      var that = this;
      var fileObj = param.file;
      var re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到后缀
        resultArr = re.exec(param.file.name);
      var type = resultArr[2];
      var code = localStorage.getItem("myCompanyCode");
      //自定义文件上传
      // console.log(param);
      var url = "/api/v1/file/getUploadSign";
      var params = { companyCode: code, fileType: "project" };
      this.catReq1Service(url, params).then(function (response) {
        if (!response.success) {
          return;
        }
        var data = response.result;
        that.host = data.host;
        var key = data.keyPrefix + "." + type;
        delete data.keyPrefix;
        delete data.host;
        that.formData = new FormData();
        that.formData.append("key", key);
        Object.keys(data).forEach(function (key) {
          // console.log(key, data[key]);
          that.formData.append(key, data[key]);
        });
        that.formData.append("file", fileObj);
        that.getFileHost(param);
      });
      // var fileObj = param.file;
      // // 接收上传文件的后台地址
      // var FileController = that.host;
      // // FormData 对象
      // var form = new URLSearchParams();
      // form.append("file", fileObj);
      // // 其他参数
      // form.append("sign", that.sign);
      // form.append("ts", that.ts);
      // form.append("token", that.token);
      // form.append("key", that.keyPrefix);
      // axios
      //   .post(FileController, form)
      //   .then(function(response) {
      //     console.log(response.data.result);
      //   })
      //   .catch(function(error) {
      //
      //   });

      // setTimeout(() => {
      //   var form = new FormData();
      //   // 文件对象
      //   form.append("file", fileObj);
      //   // 其他参数
      //   form.append("sign", that.sign);
      //   form.append("ts", that.ts);
      //   form.append("token", that.token);
      //   form.append("key", that.keyPrefix);
      //   // XMLHttpRequest 对象
      //   var xhr = new XMLHttpRequest();
      //   xhr.open("post", "/api/v1/file/upload", true);
      //   xhr.upload.addEventListener("progress", this.progressFunction, false); //监听上传进度
      //   xhr.onload = function(data) {
      //     console.log(data.srcElement.response);
      //   };
      //   xhr.send(form);
      // }, 200);
    },
    // 文件个数超出限制
    handleExceed() {
      let mes = '最多10个文件'
      this.$message.closeAll();
      this.$message({
        message: mes,
        type: "warning"
      });
    },
    // 下一步
    toFileSet() {
      var that = this;
      if (!that.sourceLang || !that.targetLang) {
        this.$message.closeAll();
        this.$message({
          message: "请选择语言!",
          type: "warning"
        });
        return;
      }
      if (that.sourceLang === that.targetLang) {
        this.$message.closeAll();
        this.$message({
          message: "源语言与目标语言不可一致！",
          type: "warning"
        });
        return;
      }
      if (!(that.sourceLang !== "zh" && that.targetLang == "zh") && !(that.sourceLang == "zh" && that.targetLang !== "zh")) {
        this.$message.closeAll();
        this.$message({
          message: "暂只支持中外互译哦~",
          type: "warning"
        });
        return;
      }
      var ary = [];
      let nameLen = true;
      if (that.fileArr.length) {
        // that.$store.state.fileList = that.fileArr;
        that.fileArr.forEach(item => {
          var re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到后缀
            resultArr = re.exec(item.name);
          var type = resultArr[2];
          if (resultArr[1].length > 160) {
            nameLen = false;
            return;
          }
          ary.push({
            name: item.name,
            filePath: item.path,
            fileSuffix: type
          });
        });
        if (!nameLen) {
          this.$message.closeAll();
          this.$message({
            message: "文件名不得超过160个字符",
            type: "warning"
          });
          return;
        }
        if (!that.fileArr[0].path) {
          this.$message.closeAll();
          this.$message({
            message: "文件未上传完毕",
            type: "warning"
          });
          return;
        }

        that.$store.commit("setFileList", ary);
        localStorage.setItem("myFilePathList", that.filePathList);
        // // debugger
        // that.$store.state.sourceLeft = that.sourceLeft;
        // that.$store.state.sourceRight = that.sourceRight;
        that.$store.commit("setSourceLeft", that.sourceLang);
        that.$store.commit("setSourceRight", that.targetLang);
        that.$router.push({
          path: "fileSet",
          query: {
            key: this.$Base64.encode(
              JSON.stringify({
                sourceLang: that.sourceLang,
                targetLang: that.targetLang,
                transFileList: ary,
                langDesc: that.sourceLeft + ">" + that.sourceRight
              })
            ),
            projectHome: that.fileArr[0].name,
            fileArr: that.fileArr,
            language: [
              that.sourceLeft,
              that.sourceRight,
              that.sourceLang,
              that.targetLang
            ],
            region: that.region,
            domainName: that.domainName,
            fieldCode: that.region,
            filesName: that.filesName
          }
        });
      } else {
        this.$message.closeAll();
        this.$message({
          message: "请先上传文件",
          type: "warning"
        });
      }
    },
    // 进度条参数
    percentageFn(index, row) {
      return row.progressPercent;
    },
    // 删除文件
    handleDelete(index) {
      var that = this;
      this.fileArr.splice(index, 1);
      that.filePathList.splice(index, 1);
      // console.log(that.token);
      // console.log(that.keyPrefix);
    },

    //     upload(fileObj) {
    //       console.log(fileObj)
    //   const formData = new FormData()
    //   formData.append('file', fileObj.file)
    //   formData.append('type', fileObj.file.type)
    //   return axios.request({
    //     url: 'https://jsonplaceholder.typicode.com/posts/',
    //     method: 'post',
    //     data: formData,
    //     onUploadProgress: progressEvent => {
    //        const complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
    //        fileObj.onProgress({ percent: complete })
    //     },
    //   }).then(this.handleUpload, this.handleUploadError)
    // },

    //上传前的函数(用于验证上传文件格式及大小)
    beforeUploadFile(file) {

      let type = this.typeReg(file.name); // 拿到文件后缀
      const isDOCX = type === "docx";
      const isDOC = type === "doc";
      const isTXT = type === "txt";
      const isXLS = type === "xls";
      const isXLSX = type === "xlsx";
      const isPDF = type === "pdf";
      const isPPT = type === "ppt";
      const isPPTX = type === "pptx";
      const isHTML = type === "html";
      const isLt20M = file.size / 1024 / 1024 < 20;
      // if (
      //   !isDOCX &&
      //   !isDOC &&
      //   !isTXT &&
      //   !isXLS &&
      //   !isXLSX &&
      //   !isPPT &&
      //   !isPPTX &&
      //   !isHTML &&
      //   !isPDF
      // ) {
      //   // this.fileArr.pop();  、pdf、ppt、pptx
      //   this.$message.closeAll();
      //   this.$message({
      //     message: "只支持 docx、doc、txt、xls、xlsx、ppt、pptx、html、pdf格式!",
      //     type: "warning"
      //   });
      //   file.obp = true;
      //   return false;
      // }
      if (FilterFileCategory(type).isFormat) {

        // this.fileArr.pop();  、pdf、ppt、pptx
        //FilterFileCategory(type).formatArr.join("、")
        this.$message.closeAll();
        this.$message({
          message: `只支持 ${FilterFileCategory(type).formatArr.join("、")}格式!`,
          type: "warning"
        });
        file.obp = true;
        return false;
      }
      //FilterFileCategory
      // let emptyFile = true; // 判断是否为空文件 、、不严谨待优化
      // if (file.size<10) {
      //   emptyFile = false;
      // }
      // if (file.size<13000 && isDOCX) {
      //   emptyFile = false;
      // }
      // if (file.size<10000 && isDOC) {
      //   emptyFile = false;
      // }
      // if (file.size<8000 && isXLS) {
      //   emptyFile = false;
      // }
      // if (file.size<11000 && isXLSX) {
      //   emptyFile = false;
      // }
      if (file.size < 1) {
        this.$message.closeAll();
        this.$message({
          message: "不支持上传空文件",
          type: "warning"
        });
        return false;
      }
      if (!LimitSize(file.size).size) {
        // this.fileArr.pop();
        this.$message.closeAll();
        this.$message({
          message: `上传文件大小不能超过 ${LimitSize(file.size).limit}MB!`,
          type: "warning"
        });
        file.obp = true;
        return false;
      }
      this.fileArr.slice(0, -1).forEach(item => {
        if (item.name == file.name) {
          this.fileArr.pop();
          this.$message.closeAll();
          this.$message({
            message: "上传文件名称重复!",
            type: "warning"
          });
          file.obp = true;
          return false;
        }
      });
      // || isPDF || isPPT || isPPTX ||
      return (!FilterFileCategory(type).isFormat) && isLt20M;
    },
    // 文件图标
    uploadChange(event, file, fileList) {
      this.fileArr.push(event)

      file.forEach(item => {
        if (item.raw) {
          switch (this.typeReg(item.name)) {
            case "pdf":
              item.imgSrc = require("../../assets/imgs/project/press_pdf.icon.png");
              this.qwer = "pdf";
              break;
            case "doc":
              item.imgSrc = require("../../assets/imgs/project/press_word.icon.png");
              this.qwer = "doc";
              break;
            case "docx":
              item.imgSrc = require("../../assets/imgs/project/press_word.icon.png");
              break;
            case "ppt":
              item.imgSrc = require("../../assets/imgs/project/press_ppt.icon.png");
              break;
            case "pptx":
              item.imgSrc = require("../../assets/imgs/project/press_ppt.icon.png");
              break;
            case "xls":
              item.imgSrc = require("../../assets/imgs/project/press_xlsx.icon.png");
              break;
            case "xlsx":
              item.imgSrc = require("../../assets/imgs/project/press_xlsx.icon.png");
              break;
            case "txt":
              item.imgSrc = require("../../assets/imgs/project/txt.png");
              break;
            case "html":
              item.imgSrc = require("../../assets/imgs/project/html.png");
              break;
            case "htm":
              item.imgSrc = require("../../assets/imgs/project/html.png");
              break;
            case "jpg":
              item.imgSrc = require("../../assets/imgs/project/tupian.png");
              break;
            case "png":
              item.imgSrc = require("../../assets/imgs/project/tupian.png");
              break;
            case "bmp":
              item.imgSrc = require("../../assets/imgs/project/tupian.png");
              break;
            case "xlf":
              item.imgSrc = require("../../assets/imgs/project/xlf.png");
              break;
            case "eml":
              item.imgSrc = require("../../assets/imgs/project/eml.png");
              break;
            default:
              break;
          }
        }
      });
    },
    // 清空文件列表弹窗
    messageIf() {
      var that = this;
      if (that.mesBox) {
        that.mesBox = false;
      } else {
        that.mesBox = true;
      }
    },
    //  清除文件列表
    empty() {
      var that = this;
      that.mesBox = false;
      that.fileArr = [];
      that.LangList2 = [];
      that.domainList = [];
      that.filePathList = [];
      that.region = "";
      that.sourceLeft = "";
      that.sourceRight = "";
      that.sourceLang = "";
      that.targetLang = "";
    },
    // 获取语言对  源语言
    getLangList(type, params) {
      var that = this;
      let obj = {
        type: type,
        [type === 1 ? "targetLang" : "sourceLang"]: params || ""
      };
      for (let propName in obj) {
        if (obj[propName] === "") {
          delete obj[propName];
        }
      }
      // debugger
      this.catReq1Service(`/api/v1/common/queryLangList`, obj).then(function (
        response
      ) {
        if (!response.success) {
          return;
        }

        if (type === 1) {
          that.LangList = response.result;
        } else {
          that.LangList2 = response.result;
        }
      });
    },
    // 选择语言对 左
    getSourceLeft(item) {

      var that = this;
      that.sourceLeft = item.sourceLangName;
      that.sourceLang = item.sourceLang;
      console.log(that.sourceLeft, that.sourceLang)
      if (this.$privatization) {
        if (that.sourceLeft !== "中文" && that.sourceLang !== "zh") {
          that.sourceRight = "中文"
          that.targetLang = "zh"
        } else {
          that.sourceRight = "英语"
          that.targetLang = "en"
        }
      }

      // this.getLangList(item.sourceLang)// 获取语言对  目标语言
      this.getLangList(2, item.sourceLang); // 获取语言对  目标语言
      this.visibleLef = false;
      that.sourceLang && that.targetLang ? that.getDomainList(that.sourceLang, that.targetLang) : null
    },
    // 选择语言对 右
    getSourceRight(item) {
      var that = this;
      // console.log(item);
      // this.getLangList(1, item.targetLang); // 获取语言对  源语言
      that.sourceRight = item.targetLangName;
      that.targetLang = item.targetLang;
      this.visibleRig = false;
      that.getDomainList(that.sourceLang, that.targetLang)
    }
  }
};
</script>
<style lang="less">
.el-table td,
.el-table th {
  text-align: center;
}
</style>
<style lang="less" scoped>
.file {
  height: calc(100% - 782px);
  margin-top: 4%;
  .talTitle {
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    padding: 0 10px;
    margin: 0 auto;
    ul {
      width: 70%;
      margin: 0 auto;
      height: 100%;
      li {
        float: left;
        height: 46px;
        line-height: 46px;
        font-size: 14px;
      }
      li:nth-child(1) {
        width: 7%;
      }
      li:nth-child(2) {
        width: 43%;
        text-align: left;
      }
      li:nth-child(3) {
        width: 12.5%;
      }
      li:nth-child(4) {
        width: 12.5%;
      }
      li:nth-child(5) {
        width: 12.5%;
      }
      li:nth-child(6) {
        width: 12.5%;
      }
    }
  }

  .bot_box {
    position: absolute;
    margin-top: 5px;
    height: 36px;
    width: 100%;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(128, 128, 128, 1);
    bottom: 0px;
    background: rgba(241, 241, 241, 1);
    span {
      float: left;
      margin-left: 20px;
      margin-top: 4px;
    }
    .dele_all {
      vertical-align: middle;
      width: 16px;
      height: 16px;
      float: right;
      margin-right: 60px;
      margin-top: 11px;
      cursor: pointer;
      background: url("../../assets/imgs/project/qb_delet_normal.png") center
        no-repeat;
    }
    .dele_all:hover {
      background: url("../../assets/imgs/project/qb_delet_press.png") center
        no-repeat;
    }
  }
  .upload_folder {
    position: absolute;
    left: 16%;
    bottom: 36%;
    width: 80px;
    height: 30px;
    cursor: pointer;
    // background: #f1f1f1;
    // border: 1px solid rgba(118, 164, 255, 1);
    border-radius: 2px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #808080;
    line-height: 28px;
    // z-index: 9;
    input {
      width: 152px;
      position: absolute;
      right: 0;
      top: 3px;
      opacity: 0;
      filter: alpha(opacity=0);
      overflow: hidden;
      cursor: pointer;
    }
  }
  .upload_folder:hover {
    border-radius: 2px;
    font-weight: 400;
    color: rgba(118, 164, 255, 1);
  }
  .upload_folder {
    position: absolute;
    left: 16%;
    bottom: 36%;
    width: 80px;
    height: 30px;
    cursor: pointer;
    // background: #f1f1f1;
    // border: 1px solid rgba(118, 164, 255, 1);
    border-radius: 2px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #808080;
    line-height: 28px;
    z-index: 9;
    input {
      width: 152px;
      position: absolute;
      right: 0;
      top: 3px;
      opacity: 0;
      filter: alpha(opacity=0);
      overflow: hidden;
      cursor: pointer;
    }
  }
  .upload_folder:hover {
    border-radius: 2px;
    font-weight: 400;
    color: rgba(118, 164, 255, 1);
  }
  .tab {
    height: 100%;
    overflow: auto;
    padding: 10px;
    box-sizing: border-box;
    padding-bottom: 36px;

    li {
      height: 46px;
      width: 100%;
      color: rgba(102, 102, 102, 1);
      font-size: 12px;
      margin: 0 auto;
      .del {
        .icon-delete {
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url("../../assets/imgs/memory/normal_delete.icon.png")
            no-repeat;
          vertical-align: middle;
        }
        .icon-delete:hover {
          background: url("../../assets/imgs/memory/hover_delete.icon.png")
            no-repeat;
        }
        .icon-delete:active {
          background: url("../../assets/imgs/memory/press_delete.icon.png")
            no-repeat;
        }
      }
      span {
        // color: aqua;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
        height: 46px;
        line-height: 46px;
        p {
          height: 18px;
          line-height: 18px;
        }
        /deep/ .el-progress-bar__outer {
          margin: 7px 0 5px 0;
        }
      }
      span:nth-child(1) {
        width: 7%;
      }
      span:nth-child(2) {
        width: 43%;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        img {
          margin-bottom: -1px;
          margin-right: 10px;
        }
      }
      span:nth-child(3) {
        width: 12.5%;
      }
      span:nth-child(4) {
        width: 12.5%;
      }
      span:nth-child(5) {
        width: 12.5%;
      }
      span:nth-child(6) {
        width: 12.5%;
      }
    }
    li:hover {
      background: rgba(210, 210, 210, 1);
      box-shadow: 0px 1px 3px 0px rgba(102, 102, 102, 0.5);
      border-radius: 2px;
    }
  }
  // /deep/.upload-demo {
  //   width: 76%;
  //   // height: 425px;
  //   // background: rgba(241, 241, 241, 1);
  //   // border: 1px solid rgba(221, 221, 221, 1);
  //   // border-radius: 2px;
  // }
  /deep/.el-upload-dragger {
    position: relative;
    width: 100%;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(241, 241, 241, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    border-radius: 2px;
  }
  /deep/.el-progress-bar__innerText {
    line-height: 15px;
  }
  /deep/.el-progress-bar__outer {
    // 进度条颜色
    background: rgba(153, 153, 153, 1) !important;
  }
  button {
    margin-top: 50px;
  }
  .ret {
    margin-right: 60px;
    background: rgba(224, 237, 252, 1);
    border: 1px solid rgba(57, 139, 241, 1);
    color: rgba(57, 139, 241, 1);
  }
  .ret:hover {
    background: rgba(184, 215, 254, 1);
  }
  .ret:active {
    background: rgba(147, 195, 255, 1);
  }
}
.uploadBox {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  img {
    margin-bottom: 30px;
  }
}
.upload-demo {
  width: 100%;
  height: calc(56% - 100px);
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  // top: 30%;
  // left: 5%;
  margin: 0 auto;
  /deep/.el-upload {
    width: 70%;
    height: 100%;
  }
  .uploadIf {
    height: 90px;
    margin-top: 95px;
    .el-icon-upload {
      display: block;
    }
  }
  .el-upload__text {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(128, 128, 128, 1);
    margin: 0 auto;
  }
}
.source {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 15%;
  display: flex;
  //margin-top: 50px;
  .icon-right {
    display: inline-block;
    width: 32px;
    height: 32px;
    text-align: center;
    cursor: pointer;
    margin: 0 20px;
    background: url("../../assets/imgs/memory/switchover.png") no-repeat;
    background-position: center;
  }
  .icon-privatization {
    display: inline-block;
    width: 32px;
    height: 32px;
    text-align: center;
    margin: 0 20px;
    background: url("../../assets/imgs/memory/youxiang_jt.png") no-repeat;
    background-position: center;
  }
  .el-select {
    width: 159px;
  }
  /deep/.el-input {
    width: 159px;
    .el-input__inner {
      text-align: center;
    }
  }
  .fieldSel {
    // margin-left: 50px;
    /deep/.el-input__inner {
      width: 159px;
    }
  }
  .domainInp {
    margin-left: 25px;
  }
}

.toFileSet {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 5%;
}

.languageBox {
  padding: 16px;
  display: flex;
  // flex-direction: column;
  flex-wrap: wrap;
  max-height: 390px;
  max-width: 450px;
  min-width: 160px;
  // .languageLi {
  //   background: rgba(225, 238, 254, 1);
  // }
  button {
    float: left !important;
    width: 140px;
    height: 30px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(53, 53, 53, 1);
    line-height: 30px;
    border-radius: 4px;
    text-align: center;
    background: white;
  }
  button:hover {
    background: rgba(231, 231, 231, 1);
  }
  button:active {
    background: rgba(210, 210, 210, 1);
  }
}

.wordName {
  img {
    vertical-align: middle;
    margin-top: -2px;
  }
  span {
    margin-left: 10px;
  }
}
</style>
